$(document).ready(function() {
  $('.nav_header_container .choice_form input[type="submit"]').appendTo($('.nav_header_container .choice_form .sub_menu_cell:last-of-type'));
});
